import { Injectable } from '@angular/core';
import {AlertController} from 'ionic-angular';
import { BluetoothSerial } from '@ionic-native/bluetooth-serial';

@Injectable()
export class PrintProvider {

  constructor(private btSerial:BluetoothSerial,private alertCtrl:AlertController) {
    
  }

  searchBt()
  {
    console.log(this.btSerial.list());
    return this.btSerial.list();
  }

  connectBT(address)
  {
    return this.btSerial.connect(address);

  }

  testPrint(count, address,printData1,printData2,printData3,printData4,printData5,printData6,printData7)
  {
   // let printData="Test hello this is a test \n\n\n\n Hello Test 123 123 123\n\n\n"
    let printData = "";
    if(count == 1)
    {
      printData = printData1;
    }
    else if (count == 2)
    {
      printData = printData2;
    }
    else if (count == 3)
    {
      printData = printData3;
    }
    else if (count == 4)
    {
      printData = printData4;
    }
    else if (count == 5)
    {
      printData = printData5;
    }
    else if (count == 6)
    {
      printData = printData6;
    }
    else {
      printData = printData7;
    }
    console.log(count);
    console.log(printData)
    let xyz=this.connectBT(address).subscribe(data=>{
      this.btSerial.write(printData).then(dataz=>{
        console.log("WRITE SUCCESS",dataz);
        
        xyz.unsubscribe();
        if(dataz == "OK")
        {
          if(count == 1)
          {
            console.log("Send Next");
            //this.testPrint(2, address,printData1,printData2,printData3,printData4,printData5,printData6,printData7);
            setTimeout(() => {
              this.testPrint(2, address,printData1,printData2,printData3,printData4,printData5,printData6,printData7);
             }, 500)
           
          }
          else if(count == 2)
          {
            console.log("Send Next");
            //this.testPrint(3, address,printData1,printData2,printData3,printData4,printData5,printData6,printData7);
            setTimeout(() => {
              this.testPrint(3, address,printData1,printData2,printData3,printData4,printData5,printData6,printData7);
             }, 500)
          }
          else if(count == 3)
          {
            console.log("Send Next");
            //this.testPrint(4, address,printData1,printData2,printData3,printData4,printData5,printData6,printData7);
            setTimeout(() => {
              this.testPrint(4, address,printData1,printData2,printData3,printData4,printData5,printData6,printData7);
             }, 500)
          }
          else if(count == 4)
          {
            console.log("Send Next");
            //this.testPrint(5, address,printData1,printData2,printData3,printData4,printData5,printData6,printData7);
            setTimeout(() => {
              this.testPrint(5, address,printData1,printData2,printData3,printData4,printData5,printData6,printData7);
             }, 500)
          }
          else if(count == 5)
          {
            console.log("Send Next");
            //this.testPrint(6, address,printData1,printData2,printData3,printData4,printData5,printData6,printData7);
            setTimeout(() => {
              this.testPrint(6, address,printData1,printData2,printData3,printData4,printData5,printData6,printData7);
             }, 500)
          }
          else if(count == 6)
          {
            console.log("Send Next");
            //this.testPrint(7, address,printData1,printData2,printData3,printData4,printData5,printData6,printData7);
            setTimeout(() => {
              this.testPrint(7, address,printData1,printData2,printData3,printData4,printData5,printData6,printData7);
             }, 500)
          }
          else
          {
            let mno=this.alertCtrl.create({
              title:"Print SUCCESS!",
              buttons:['Dismiss']
            });
            mno.present();
          }
        }
       
      },errx=>{
        console.log("WRITE FAILED",errx);
        let mno=this.alertCtrl.create({
          title:"ERROR "+errx,
          buttons:['Dismiss']
        });
        mno.present();
      });
    },err=>{
      console.log("CONNECTION ERROR",err);
      let mno=this.alertCtrl.create({
        title:"ERROR "+err,
        buttons:['Dismiss']
      });
      mno.present();
    });

  }

}



// WEBPACK FOOTER //
// ./src/providers/print/print.ts